'use strict';
import * as $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest from "./app.data.-App-Document-Data-Create-Request.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin(request) {
  this.a8p = null;
  this.a8p = request;
}
export { $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin as $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin };
$p = $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin.prototype = new $j_app$002edata$002e$002dApp$002dDocument$002dData$002dCreate$002dRequest.$h_Lapp_data_AppDocumentDataCreateRequest();
$p.constructor = $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin;
/** @constructor */
function $h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin() {
}
export { $h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin as $h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin };
$h_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin)) {
    var x = this.a8p;
    var x$2 = x$0.a8p;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "CertificateOfOrigin";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.a8p;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "request";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 2;
});
function $isArrayOf_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.iO)));
}
export { $isArrayOf_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin as $isArrayOf_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin };
var $d_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin, "app.data.AppDocumentDataCreateRequest$CertificateOfOrigin", ({
  iO: 1,
  dC: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin as $d_Lapp_data_AppDocumentDataCreateRequest$CertificateOfOrigin };
//# sourceMappingURL=app.data.-App-Document-Data-Create-Request$-Certificate-Of-Origin.js.map
